module.exports = __webpack_public_path__ + "img/medalha-01.ce80de1a.jpg";